// extracted by mini-css-extract-plugin
export default {"modalbody":"Modal_modalbody__BEedW","close-btn":"Modal_close-btn__HKyBn"};